import { PayoutStatus } from '@nemuru-eng/js-api-client';

import { StatusTagType } from '../../../../../config/types';

export const ALLOWED_PAYOUT_STATUSES_FOR_MULTI_SELECT_FILTER = [PayoutStatus.DISBURSED, PayoutStatus.IN_REVIEW];

export const PAYOUT_STATUS_DEFINITIONS = {
  [PayoutStatus.IN_REVIEW]: {
    type: StatusTagType.WARNING,
    SECTION_T_ID: PayoutStatus.IN_REVIEW,
  },
  [PayoutStatus.PUBLISHING]: {
    type: StatusTagType.INFO,
    SECTION_T_ID: PayoutStatus.PUBLISHING,
  },
  [PayoutStatus.PUBLISHED]: {
    type: StatusTagType.SUCCESS,
    SECTION_T_ID: PayoutStatus.PUBLISHED,
  },
  [PayoutStatus.DISBURSED]: {
    type: StatusTagType.SUCCESS,
    SECTION_T_ID: PayoutStatus.DISBURSED,
  },
};
